
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractButton, PopoutButtonComponent } from '@jeppesen-foreflight/jmkw-toolkit';
import { ButtonParams } from '@jeppesen-foreflight/jmkw-types';
import { MockSearchPopoutComponent } from './popout/mock-search-popout.component';

@Component({
  selector: 'test-core-mock-search',
  standalone: true,
  imports: [PopoutButtonComponent],
  templateUrl: './mock-search.button.html',
  styleUrl: './mock-search.button.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MockSearchButtonComponent extends AbstractButton {
  iconName = 'icon-search';
  automationKey = 'mock-search-button';
  tooltipText = 'Mock Search';
  componentRef = MockSearchPopoutComponent;
}

export const MOCK_SEARCH_BUTTON: ButtonParams = {
  iconName: 'icon-search',
  tooltipText: 'Mock Search',
  buttonComponent: MockSearchButtonComponent,
  stateFn: () => false // Button is never in "active" state
};
